import { CalendarDays, Clock, Users, MapPin, Wallet, CreditCard } from "lucide-react";
import { prettyDate, priceLabel } from "./utils";
import { useBT } from "./i18n";

export const BookingSummary = ({ booking }) => {
  const { t, locale } = useBT();
  return (
    <dl className="grid gap-3 text-sm" data-testid="booking-summary">
      <Row icon={MapPin} label={t.sExperience} value={booking.service_name} testid="summary-service" />
      <Row icon={CalendarDays} label={t.sDate} value={prettyDate(booking.date, locale)} testid="summary-date" />
      <Row icon={Clock} label={t.sTime} value={booking.time} testid="summary-time" />
      <Row icon={Users} label={t.sGuests} value={booking.guests} testid="summary-guests" />
      {booking.resource_unit && <Row icon={MapPin} label={t.sSpot} value={booking.resource_unit} testid="summary-unit" />}
      <Row icon={Wallet} label={t.sPrice} value={priceLabel(booking, t)} testid="summary-price" />
      {booking.deposit_amount > 0 && (
        <Row icon={CreditCard} label={t.deposit} testid="summary-deposit"
          value={`€${booking.deposit_amount} · ${t.pay[booking.payment_status] || booking.payment_status || ""}`} />
      )}
    </dl>
  );
};

const Row = ({ icon: Icon, label, value, testid }) => (
  <div className="flex items-center gap-3">
    <Icon size={15} className="text-[#b09873] shrink-0" />
    <dt className="w-24 text-[#1d2b31]/60">{label}</dt>
    <dd className="font-medium" data-testid={testid}>{value}</dd>
  </div>
);
